import currentUserModule from "./currentUserModule"


currentUserModule.service("currentUserService", function (authenticationService, $state) {

    this.logout = () => {
        authenticationService.logOut()
        authenticationService.setTargetState($state.current.name, $state.current.params || $state.params)
        $state.go("login")
    }

})
